// extracted by mini-css-extract-plugin
export default {"markdown":"nHYXyF60BIDQEYDancVA__markdown___"};